import React from 'react'
import "../styles/race.css"
import whhorse from "../assets/images/whitehorse.png"
import coin from "../assets/images/coin.png"
import flag from "../assets/images/flag.png"

const Race = () => {
    return (
        <div className="container">
            <div className="section">
                <section>
                    <div className="columns is-mobile is-centered css-1ri2dqj">
                        <div className="column is-two-thirds-widescreen text-center">
                            <p className="is-size-1 is-size-3-mobile mb-5 css-1r7ye4j">
                                <span className="font-weight-semibold text-center">Join Daytona Racing Car Club</span><br />
                                <span className="font-weight-semibold text-center">Horse Racing Metaverse!</span>
                            </p>
                        </div>
                    </div>
                    <div className="columns is-mobile is-centered">
                        <div className="column container">
                            <div
                                className="columns row pb-6 justify-content-center align-items-center css-78hqm">
                                <div
                                    className="column col-md ">
                                    <a href="https://derace.com/horses">
                                        <div className="css-1uvxoz3 box">
                                            <div
                                                className="px-4 pb-5 pt-3 css-o6cui7">
                                                <div
                                                    className="columns is-mobile is-multiline contained">
                                                    <div
                                                        className="column is-two-fifths-mobile box-img is-full-desktop has-text-centered css-xewkul">
                                                        <img src={whhorse}
                                                            className="ml-5 ms-5 box-main-img css-1afm6k5" />
                                                    </div>
                                                    <div
                                                        className="column is-three-fifths-mobile is-full-desktop css-2qf2of">
                                                        <p
                                                            className="is-size-4 font-weight-semibold css-1r7ye4j">
                                                            Own
                                                            a
                                                            racehorse
                                                        </p>
                                                        <p
                                                            className="my-3">Have a one-of-a-kind NFT horse ready in your own stables.
                                                        </p>
                                                        <a href="https://opensea.io/collection/derace-horses"
                                                            className="d-flex align-items-center"><span>Explore
                                                                NFT
                                                                horses</span><svg
                                                                    stroke="currentColor"
                                                                    fill="none"
                                                                    stroke-width="0"
                                                                    viewBox="0 0 24 24"
                                                                    className="ml-2"
                                                                    height="1em"
                                                                    width="1em"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                <path stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                    stroke-width="2"
                                                                    d="M17 8l4 4m0 0l-4 4m4-4H3">
                                                                </path>
                                                            </svg></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div
                                    className="column col-md ">
                                    <a href="https://derace.com/derc">
                                        <div className="css-1uvxoz3 box">
                                            <div
                                                className="px-4 pb-5 pt-3 css-o6cui7">
                                                <div
                                                    className="columns is-mobile is-multiline contained">
                                                    <div
                                                        className="column is-two-fifths-mobile is-full-desktop has-text-centered css-xewkul box-img">
                                                        <img src={coin}
                                                            className="ml-5 ms-5 box-main-img css-1afm6k5" alt="coin" />
                                                    </div>
                                                    <div
                                                        className="column is-three-fifths-mobile is-full-desktop css-2qf2of">
                                                        <p
                                                            className="is-size-4 has-text-weight-semibold css-1r7ye4j">
                                                            Hold
                                                            $DayTona
                                                        </p>
                                                        <p
                                                            className="my-3">
                                                            Make
                                                            sure
                                                            you
                                                            have
                                                            some
                                                            $DayTona
                                                            for
                                                            entry
                                                            fee
                                                            and
                                                            breeding.
                                                        </p>
                                                        <a className="d-flex align-items-center"
                                                            href="https://derace.com/derc"><span>Acquire
                                                                $DayTona</span><svg
                                                                    stroke="currentColor"
                                                                    fill="none"
                                                                    stroke-width="0"
                                                                    viewBox="0 0 24 24"
                                                                    className="ml-2"
                                                                    height="1em"
                                                                    width="1em"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                <path stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                    stroke-width="2"
                                                                    d="M17 8l4 4m0 0l-4 4m4-4H3">
                                                                </path>
                                                            </svg></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div
                                    className="column col-md ">
                                    <a href="https://derace.com/races">
                                        <div className="css-1uvxoz3 box">
                                            <div
                                                className="px-4 pb-5 pt-3 css-o6cui7">
                                                <div
                                                    className="columns is-multiline is-mobile contained">
                                                    <div
                                                        className="column is-two-fifths-mobile box-img is-full-desktop has-text-centered css-xewkul">
                                                        <img src={flag}
                                                            className="ml-5 ms-5 box-main-img css-1afm6k5" alt="Race-Flag"/>
                                                    </div>
                                                    <div
                                                        className="column is-three-fifths-mobile is-full-desktop css-2qf2of">
                                                        <p
                                                            className="is-size-4 has-text-weight-semibold css-1r7ye4j">
                                                            Race
                                                        </p>
                                                        <p
                                                            className="my-3">
                                                            Prove
                                                            your
                                                            horse
                                                            to
                                                            be
                                                            the
                                                            ultimate
                                                            DayTona Racing Car CLub
                                                            metaverse
                                                            champion.
                                                        </p>
                                                        <a className="d-flex align-items-center"
                                                            href="https://derace.com/races"><span>Join
                                                                the
                                                                races</span><svg
                                                                    stroke="currentColor"
                                                                    fill="none"
                                                                    stroke-width="0"
                                                                    viewBox="0 0 24 24"
                                                                    className="ml-2"
                                                                    height="1em"
                                                                    width="1em"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                <path stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                    stroke-width="2"
                                                                    d="M17 8l4 4m0 0l-4 4m4-4H3">
                                                                </path>
                                                            </svg></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div >
                </section >
            </div >
        </div >
    )
}

export default Race;